import * as THREE from "three";
import * as CANNON from "cannon-es";
import CannonDebugRenderer from "cannon-es-debugger";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader.js";
import { TextureLoader } from "three";
import { EventTarget } from "cannon";
import SceneInit from "../lib/SceneInit";

//scene
const scene = new THREE.Scene();

//camera
const camera = new THREE.PerspectiveCamera(
  75,
  window.innerWidth / window.innerHeight,
  0.1,
  1000
);

//render
const renderer = new THREE.WebGLRenderer();
renderer.setSize(window.innerWidth, window.innerHeight);
document.body.appendChild(renderer.domElement);

//OrbitControls
const controls = new OrbitControls(camera, renderer.domElement);

//lights
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;
const ambient = new THREE.AmbientLight(0x888888);
scene.add(ambient);
const light = new THREE.DirectionalLight(0xdddddd);
light.position.set(3, 10, 4);
light.target.position.set(0, 0, 0);
light.castShadow = true;
const lightSize = 10;

scene.add(light);

// creating landscape
const sizeX = 128; // Текущая длина
const sizeY = 128; // Текущая ширина
const scale = 2; // Масштабирование в 2 раза

const extendedSizeX = sizeX * scale;
const extendedSizeY = sizeY * scale;
const edgeHeightCannon = 50.0;

const matrix = [];

for (let i = 0; i < extendedSizeX + 1; i++) {
  matrix.push([]);
  for (let j = 0; j < extendedSizeY + 1; j++) {
    // Вычислите новую высоту с учетом масштабирования
    const originalI = Math.floor(i / scale);
    const originalJ = Math.floor(j / scale);
    let height =
      Math.cos((originalI / sizeX) * Math.PI * 5) *
        Math.cos((originalJ / sizeY) * Math.PI * 5) *
        2 +
      2;
    matrix[i].push(height);
  }
}

// inscreasing matrix for edges
const extendedMatrix = [];

for (let i = 0; i < extendedSizeX; i++) {
  extendedMatrix.push([]);
  for (let j = 0; j < extendedSizeY; j++) {
    let height = 0;

    // inscreasing
    if (
      i === 0 ||
      i === extendedSizeX - 1 ||
      j === 0 ||
      j === extendedSizeY - 1
    ) {
      height = edgeHeightCannon;
    } else {
      // inner points remain standard
      const rowIndex = i - 1;
      const colIndex = j - 1;
      height = matrix[rowIndex][colIndex];
    }

    extendedMatrix[i].push(height);
  }
}

//Three plane
const elementSize = 100 / sizeX; // Используем elementSize из hfShape
const planeWidth = sizeX * elementSize;
const planeHeight = sizeY * elementSize;
const segmentsX = sizeX;
const segmentsY = sizeY;
const edgeHeight = edgeHeightCannon;

// const planeGeometry = new THREE.PlaneGeometry(
//   planeWidth,
//   planeHeight,
//   segmentsX,
//   segmentsY
// );
// planeGeometry.rotateX(-Math.PI / 2);

// /////////////////////////////////////
// const planeMaterial = new THREE.MeshPhongMaterial({
//   color: 0x888888,
//   // wireframe: true,
//   flatShading: true,
// });

// const planeMesh = new THREE.Mesh(planeGeometry, planeMaterial);
// planeMesh.receiveShadow = true;

// scene.add(planeMesh);

//three body
const redMaterial = new THREE.MeshPhongMaterial({ color: 0xff0000 });

const boxGeometry = new THREE.BoxGeometry(8, 1.7, 4);
const boxMaterial = new THREE.MeshNormalMaterial();
const boxMesh = new THREE.Mesh(boxGeometry, redMaterial);
scene.add(boxMesh);

//three wheels

const sphereGeometry1 = new THREE.SphereGeometry(1);
const sphereMesh1 = new THREE.Mesh(sphereGeometry1, redMaterial);
scene.add(sphereMesh1);

const sphereGeometry2 = new THREE.SphereGeometry(1);
const sphereMesh2 = new THREE.Mesh(sphereGeometry2, redMaterial);
scene.add(sphereMesh2);

const sphereGeometry3 = new THREE.SphereGeometry(1);
const sphereMesh3 = new THREE.Mesh(sphereGeometry3, redMaterial);
scene.add(sphereMesh3);

const sphereGeometry4 = new THREE.SphereGeometry(1);
const sphereMesh4 = new THREE.Mesh(sphereGeometry4, redMaterial);
scene.add(sphereMesh4);

//cannon world
const physicsWorld = new CANNON.World({
  gravity: new CANNON.Vec3(0, -9.82, 0),
});

const cannonDebugger = new CannonDebugRenderer(scene, physicsWorld);
//////////////////////////////////////////

//cannon ground

// Создайте плоскую форму Cannon.js
// const groundShape = new CANNON.Plane();

// // Создайте тело Cannon.js для земли и используйте созданную форму
// const groundBody = new CANNON.Body({
//   type: CANNON.Body.STATIC,
//   shape: groundShape,
// });

const hfShape = new CANNON.Heightfield(extendedMatrix, {
  elementSize: 100 / sizeX,
});

const groundBody = new CANNON.Body({ mass: 0 });
groundBody.addShape(hfShape);
groundBody.position.set(
  (-extendedSizeX * hfShape.elementSize) / 2,
  -4,
  (extendedSizeY * hfShape.elementSize) / 2
);

// Установите позицию плоскости Cannon.js так, чтобы она совпадала с Three.js

// rotate ground body by 90 degrees
groundBody.quaternion.setFromEuler(-Math.PI / 2, 0, 0);
physicsWorld.addBody(groundBody);

//////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////

// physicsWorld.broadphase = new CANNON.SAPBroadphase(physicsWorld);
// physicsWorld.defaultContactMaterial.friction = 0;
// const groundMaterial = new CANNON.Material("groundMaterial");

//cannon body
const initialRotation = new CANNON.Quaternion();
initialRotation.setFromAxisAngle(new CANNON.Vec3(0, 1, 0), Math.PI / 2);
const carBody = new CANNON.Body({
  mass: 5,
  position: new CANNON.Vec3(0, 6, 0),
  shape: new CANNON.Box(new CANNON.Vec3(4, 0.7, 2)),
});
carBody.quaternion.copy(initialRotation);

//cannon wheels
const vehicle = new CANNON.RigidVehicle({
  chassisBody: carBody,
});

vehicle.addToWorld(physicsWorld);

// add wheels to the vehicle
const mass = 1;
const axisWidth = 5;
const wheelShape = new CANNON.Sphere(1);
const wheelMaterial = new CANNON.Material("wheel");
const down = new CANNON.Vec3(0, -1, 0);

// const wheelGroundContactMaterial = new CANNON.ContactMaterial(
//   wheelMaterial,
//   groundMaterial,
//   {
//     friction: 1,
//     restitution: 0,
//     contactEquationStiffness: 1000,
//   }
// );
// physicsWorld.addContactMaterial(wheelGroundContactMaterial);

const wheelBody1 = new CANNON.Body({ mass, material: wheelMaterial });
wheelBody1.addShape(wheelShape);
wheelBody1.angularDamping = 0.4;
vehicle.addWheel({
  body: wheelBody1,
  position: new CANNON.Vec3(-2, 0, axisWidth / 2),
  axis: new CANNON.Vec3(0, 0, 1),
  direction: down,
});

const wheelBody2 = new CANNON.Body({ mass, material: wheelMaterial });
wheelBody2.addShape(wheelShape);
wheelBody2.angularDamping = 0.4;
vehicle.addWheel({
  body: wheelBody2,
  position: new CANNON.Vec3(-2, 0, -axisWidth / 2),
  axis: new CANNON.Vec3(0, 0, 1),
  direction: down,
});

const wheelBody3 = new CANNON.Body({ mass, material: wheelMaterial });
wheelBody3.addShape(wheelShape);
wheelBody3.angularDamping = 0.4;
vehicle.addWheel({
  body: wheelBody3,
  position: new CANNON.Vec3(2, 0, axisWidth / 2),
  axis: new CANNON.Vec3(0, 0, 1),
  direction: down,
});

const wheelBody4 = new CANNON.Body({ mass, material: wheelMaterial });
wheelBody4.addShape(wheelShape);
wheelBody4.angularDamping = 0.4;
vehicle.addWheel({
  body: wheelBody4,
  position: new CANNON.Vec3(2, 0, -axisWidth / 2),
  axis: new CANNON.Vec3(0, 0, 1),
  direction: down,
});

vehicle.addToWorld(physicsWorld);

// move car
document.addEventListener("keydown", (event) => {
  const maxSteerVal = Math.PI / 8;
  const maxForce = 10;

  switch (event.key) {
    case "w":
    case "ArrowUp":
      vehicle.setWheelForce(maxForce, 0);
      vehicle.setWheelForce(maxForce, 1);
      break;

    case "s":
    case "ArrowDown":
      vehicle.setWheelForce(-maxForce / 2, 0);
      vehicle.setWheelForce(-maxForce / 2, 1);
      break;

    case "a":
    case "ArrowLeft":
      vehicle.setSteeringValue(maxSteerVal, 0);
      vehicle.setSteeringValue(maxSteerVal, 1);
      break;

    case "d":
    case "ArrowRight":
      vehicle.setSteeringValue(-maxSteerVal, 0);
      vehicle.setSteeringValue(-maxSteerVal, 1);
      break;
  }
});

// reset car force to zero when key is released
document.addEventListener("keyup", (event) => {
  switch (event.key) {
    case "w":
    case "ArrowUp":
      vehicle.setWheelForce(0, 0);
      vehicle.setWheelForce(0, 1);
      break;

    case "s":
    case "ArrowDown":
      vehicle.setWheelForce(0, 0);
      vehicle.setWheelForce(0, 1);
      break;

    case "a":
    case "ArrowLeft":
      vehicle.setSteeringValue(0, 0);
      vehicle.setSteeringValue(0, 1);
      break;

    case "d":
    case "ArrowRight":
      vehicle.setSteeringValue(0, 0);
      vehicle.setSteeringValue(0, 1);
      break;
  }
});

//follow cam
// camera.position.set(25, 10, 25);
const cameraTarget = new THREE.Object3D();
scene.add(cameraTarget);
const initialCameraPosition = new THREE.Vector3(0, 10, 20);
const targetPosition = new THREE.Vector3(0, 6, -10);
camera.position.copy(initialCameraPosition);
camera.lookAt(targetPosition);
const cameraOffset = new THREE.Vector3(0, 5, -10);

//animate
const animate = () => {
  physicsWorld.fixedStep();
  cannonDebugger.update();

  boxMesh.position.copy(carBody.position);
  boxMesh.quaternion.copy(carBody.quaternion);
  sphereMesh1.position.copy(wheelBody1.position);
  sphereMesh1.quaternion.copy(wheelBody1.quaternion);
  sphereMesh2.position.copy(wheelBody2.position);
  sphereMesh2.quaternion.copy(wheelBody2.quaternion);
  sphereMesh3.position.copy(wheelBody3.position);
  sphereMesh3.quaternion.copy(wheelBody3.quaternion);
  sphereMesh4.position.copy(wheelBody4.position);
  sphereMesh4.quaternion.copy(wheelBody4.quaternion);

  cameraTarget.position.copy(carBody.position);
  cameraTarget.position.add(targetPosition); // Смещаем цель камеры к машине
  cameraTarget.quaternion.copy(carBody.quaternion);
  const cameraPosition = new THREE.Vector3();
  cameraPosition.copy(cameraTarget.position);
  cameraPosition.add(cameraOffset); // Применяем смещение к позиции цели

  camera.position.copy(cameraPosition);
  camera.lookAt(cameraTarget.position);
  controls.update();

  renderer.render(scene, camera);
  window.requestAnimationFrame(animate);
};
animate();

window.addEventListener("resize", onWindowResize, false);
function onWindowResize() {
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
  renderer.setSize(window.innerWidth, window.innerHeight);
}
